<div class="transport-option-condition-editor" *ngIf="condition" [formGroup]="detailsFormGroup">
    
    <div class="row">
        <mat-form-field class="flex-grow">
            <mat-label>
                {{'transport option' | translate:
                ['tmc-yard.widgets.filter-administration.details-editor.transport.transport-option-condition-editor.transportoption',
                translationService.language]}}
            </mat-label>
            <mat-select formControlName="transportOptionExternalKey" name="transportOptionExternalKey">

                <mat-option [value]="-1">
                    {{"no selection" |
                    translate:['tmc-yard.widgets.filter-administration.details-editor.transport.transport-option-condition-editor.transportoption.none',
                    translationService.language]}}
                </mat-option>

                <ng-container *ngFor="let to of transportOptions">
                    <mat-option [value]="to.externalKey">
                        {{to.nameDictionaryKey | translate:[to.nameDictionaryKey, translationService.language]}}
                    </mat-option>

                    <ng-container *ngFor="let child of to.transportOptions">
                        <mat-option [value]="child.externalKey">
                            &nbsp;&nbsp;{{child.nameDictionaryKey | translate:[child.nameDictionaryKey,
                            translationService.language]}}
                        </mat-option>
                    </ng-container>

                </ng-container>

            </mat-select>
        </mat-form-field>
    </div>
</div>